import { UserManager, UserManagerSettings } from "oidc-client-ts";
import { RouteNames } from "../enums/RouteNames";

const config: UserManagerSettings = {
  authority: process.env.REACT_APP_ONELOGIN_AUTHORITY ?? '',
  client_id: process.env.REACT_APP_ONELOGIN_CLIENT_ID ?? '',
  client_secret: process.env.REACT_APP_ONELOGIN_CLIENT_SECRET ?? '',
  redirect_uri: `${window.location.origin}${RouteNames.AUTHENTICATE}`,
  response_type: 'code',
  scope: 'openid profile email params',
  post_logout_redirect_uri: `${window.location.origin}${RouteNames.LOGIN}`
};

class AuthenticationService {
  public static getUserManager(): UserManager {
    return new UserManager(config);
  }
}

export default AuthenticationService;
